import React, {useEffect, useMemo, useRef, useState} from 'react';
import {useAppDispatch, useAppSelector} from "../../../redux/hooks";
import {Badge} from "primereact/badge";
import {Dropdown} from "primereact/dropdown";
import {classNames} from "primereact/utils";
import {getUserDetails, getUserStatus, getUserStatuses, updateUserStatus} from "../../../redux/api/apiUsersList";
import {clearAllStates, setEditType} from "../../../redux/actions/actions";
import {setRolesVisible} from "../../../redux/actions/actionsRoles";
import {useNavigate} from "react-router-dom";
import {ERROR_ACCOUNT_WEB_LOGIN} from "../../../redux/types/types";
import {changeActiveTab, stopGlobalJsSIP, terminateAllActiveCallsWithUserHeader} from "../../JsSip/GlobalJsSIP";
import {Button} from "primereact/button";
import InternetStatus from "../InternetStatus";
import {reconnectTab, setActiveSessionTab, setReconnectSession} from "../../../redux/actions/actionsWebRTC";
import {Divider} from "primereact/divider";
import UserListDialog from "../../Settings/UsersList/UserDialod";
import {checkPermissions} from "../../../redux/permissions/permissionsUtils";
import {logAction, logLogout, restoreUserConsoleLogsToStorage} from "../../../utils/appEventLogs";

const InlineProfileMenu = (props: any) => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const user = useAppSelector(state => state.UsersReducer.userData);
    const statusHubError = useAppSelector(state => state.WebRTCReducer.statusHubError);
    const monitoringHubError = useAppSelector(state => state.WebRTCReducer.monitoringHubError);
    const userDataHubError = useAppSelector(state => state.WebRTCReducer.userDataHubError);
    const dialerHubError = useAppSelector(state => state.WebRTCReducer.dialerHubError);
    const userStatus = useAppSelector(state => state.UsersListReducer.userStatus);
    const userStatusObj = Array.isArray(userStatus) && userStatus.length > 0 ? userStatus[0] : (userStatus && typeof userStatus === 'object' && !Array.isArray(userStatus) ? userStatus : null);
    const activeTab = useAppSelector(state => state.WebRTCReducer.activeTab);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const detailsLoading = useAppSelector(state => state.UsersListReducer.detailLoading);
    const jwtToken = useAppSelector(state => state.UsersReducer.userData.jwtToken);
    const hash = window.location.hash;
    const statuses = useAppSelector(state => state.UsersListReducer.statuses);
    const dropdownRef = useRef<any>(null);
    const recallNumber = useAppSelector(state => state.WebRTCReducer.recallNumber);
    const autoReload = useAppSelector(state => state.MonitoringListReducer.autoReload);
    const [dateTime, setDateTime] = useState(new Date());
    const [userActivatedTab, setUserActivatedTab] = useState(false);
    const rolesVision = useAppSelector(state => state.RolesReducer.rolesVision) as unknown as Record<string, string[]>;
    const usersManagerPermissions = checkPermissions(rolesVision, 'Users');
    const {
        visible: hasUsersManagerVisionPermission,
        update: hasUsersManagerUpdatePermission,
    } = usersManagerPermissions;
    const allStatuses = useMemo(() => {
        const additionalStatus = {
            id: 1,
            externalName: "LOGOUT",
            statusName: "Logout",
            displayOrder: 1,
            statusColor: "rgb(177, 177, 177)",
            statusImagePath: null,
            description: ""
        };

        if (statuses?.length) {
            return [...statuses, additionalStatus];
        } else {
            return [additionalStatus];
        }
    }, [statuses]);

    useEffect(() => {
        dispatch(getUserStatuses(jwtToken?.jwtToken));
        dispatch(getUserStatus(jwtToken?.jwtToken))
    }, []);

    useEffect(() => {
        if (recallNumber) {
            if (props.profileMenuActiveChange) {
                props.profileMenuActiveChange(true);
            }
        }
    }, [recallNumber]);

    const handleBadgeClick = () => {
        if (dropdownRef.current) {
            dropdownRef.current.show();
        }
    };

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        const interval = setInterval(() => {
            setDateTime(new Date());
        }, 1000);

        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        if (!props.showIconAsInactive) {
            setUserActivatedTab(false);
        }
    }, [props.showIconAsInactive]);

    useEffect(() => {
        if (!activeTab) {
            setUserActivatedTab(false);
        }
    }, [activeTab]);

    const handleStatusChange = (event: any) => {
        let data = {
            userId: user?.userId,
            statusesId: event.value
        }
        if (event.value !== 1) {
            logAction('status_change', {statusesId: event.value, userId: user?.userId});
            dispatch(updateUserStatus(data, jwtToken?.jwtToken, null, true));
        } else {
            logAction('user_menu_logout', {userId: user?.userId});
            dispatch(updateUserStatus(data, jwtToken?.jwtToken, null, true));
            logLogout('user_menu');
            terminateAllActiveCallsWithUserHeader('logout');
            sessionStorage.setItem('isLoggedOut', 'true');
            sessionStorage.removeItem('expirationTime');
            navigate('/login');
            sessionStorage.removeItem('authToken');
            localStorage.removeItem('authToken');
            stopGlobalJsSIP();
            localStorage.clear();
            localStorage.removeItem('persist:callcenter:user');
            dispatch(clearAllStates());
            dispatch(setRolesVisible(null));
            dispatch({type: ERROR_ACCOUNT_WEB_LOGIN, payload: {"statusCode": null, "title": null, "message": null, "data": null}})
            restoreUserConsoleLogsToStorage();
        }
    };

    const statusClass = classNames({
        'p-badge status-unsuccessful': userStatusObj?.statusName === 'Unsuccess',
        'p-badge status-success': userStatusObj
    });

    const getStatusNameById = (id: number) => {
        const selectedStatus = statuses.find((status: { id: number; }) => status.id === id);
        const replaceStatusName = selectedStatus?.statusName?.replace(/Copy.*/, 'Copy...');
        return replaceStatusName ? replaceStatusName : '';
    }

    function customItemTemplate(option: any) {
        return (<>
                {option?.id !== 1 ? <div className="custom-dropdown-option">
                        {option.statusName}
                    </div> :
                    <ul className="list-none p-0">
                        <li className="layout-inline-menu-action-item">
                            <button className="p-link text-white">
                                <i className="pi pi-fw pi-sign-out mr-2"></i>
                                <span>{option.statusName}</span>
                            </button>
                        </li>
                    </ul>}
            </>
        );
    }

    const filteredStatusList = allStatuses?.filter((status: { isAutoStatus: boolean; }) => !status.isAutoStatus);

    const clickActive = () => {
        if (props.profileMenuActiveChange) {
            props.profileMenuActiveChange(true);
        }
        if (typeof window !== 'undefined') {
            try {
                if (!window.name) {
                    window.name = `callcentre-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
                }
                sessionStorage.setItem('callCentreForceActiveWindowId', window.name);
            } catch (e) {
            }
        }
        setUserActivatedTab(true);
        changeActiveTab();
        props.setIsActiveTab(true);
        dispatch(setActiveSessionTab(true));
        dispatch(reconnectTab(true));

        if (!activeTab) {
            dispatch(setReconnectSession(true));
            setTimeout(() => {
                dispatch(setReconnectSession(false));
            }, 100);
        }
    };

    return (
        <>
            <div className='layout-inline-menu flex align-items-center relative inlineProfile'>
                <div className="layout-inline-menu-action p-link pt-1 align-items-start">
                    <div className="flex mr-3 notify-mobile-hub">
                        {monitoringHubError && hash === '#/monitoring' && autoReload && <div className="routerContainer flex relative border-circle justify-content-center align-items-center signal-strength-offline mr-2">
                            <i style={{color: "red"}} className="pi pi-chart-bar text-xl"></i>
                        </div>}
                        {statusHubError && <div className="routerContainer flex relative border-circle justify-content-center align-items-center signal-strength-offline mr-2">
                            <i style={{color: "red"}} className="pi pi-verified text-xl"></i>
                        </div>}
                        {userDataHubError && <div className="routerContainer flex relative border-circle justify-content-center align-items-center signal-strength-offline mr-2">
                            <i style={{color: "red"}} className="pi pi-users text-xl"></i>
                        </div>}
                        {dialerHubError && hash === '#/' && <div className="routerContainer flex relative border-circle justify-content-center align-items-center signal-strength-offline mr-2">
                            <i style={{color: "red"}} className="pi pi-folder text-xl"></i>
                        </div>}</div>
                    <div className="hidden md:flex flex-column mr-2 signal-datetime-block" onClick={clickActive}>
                        <div className="flex mb-2">
                            <InternetStatus/>
                            {(activeTab && !props.showIconAsInactive) || (props.showIconAsInactive && userActivatedTab) ?
                                <Button icon="pi pi-phone" className="text-xl phone-icon outline-none shadow-none border-none cursor-pointer p-button-success text-white ml-2 border-circle" style={{backgroundColor: 'rgb(76, 175, 80)', width: '30px', height: '30px', fontSize: '30px'}}
                                        ></Button>
                                : <Button icon="pi pi-phone" className="text-xl phone-icon outline-none shadow-none cursor-pointer p-button-success text-white mx-2 ml-0 border-circle relative overflow-visible flex justify-content-center"
                                          style={{backgroundColor: '#b3bac5', width: '30px', height: '30px', fontSize: '30px', border: '1px solid red'}} onClick={clickActive}><i className="offline-icon-phone pi pi-times"></i></Button>}
                        </div>
                        <div className="flex">
                            <p className="mr-2 mb-0 text-sm">{dateTime.toLocaleDateString("uk-UA")}</p>
                            <p className="mb-0 text-sm">{dateTime.toLocaleTimeString("uk-UA", {
                                hour12: false,
                                hour: "2-digit",
                                minute: "2-digit"
                            })}</p>
                        </div>
                    </div>
                    <Divider layout="vertical" className="vertical my-0 hidden md:block inline-profile-divider"/>
                    <div className="flex flex-column inline-profile-info">
                        <div className="flex mb-3 align-items-center">
                            <div className="flex align-items-center" onClick={() => {
                                if (hasUsersManagerUpdatePermission || hasUsersManagerVisionPermission) {
                                    dispatch(getUserDetails(user.userId, jwtToken?.jwtToken, true));
                                    if (hasUsersManagerUpdatePermission) {
                                        dispatch(setEditType(true));
                                    } else {
                                        dispatch(setEditType(false));
                                    }
                                }
                            }}>
                                <i className={detailsLoading ? 'pi pi-spin pi-spinner' : hasUsersManagerUpdatePermission ? "pi pi-pencil" : hasUsersManagerVisionPermission ? "pi pi-eye" : ''} style={{ fontSize: '1rem' }}></i>
                                {user ? <span className="layout-inline-menu-text text-lg ml-2">{user?.userName}</span> : <span className="layout-inline-menu-text">Unknown</span>}
                            </div>
                        </div>
                        {userStatusObj && userStatusObj?.statusColor && <div className="flex mx-1 p-0" style={{minWidth: '160px'}}>
                            <Badge onClick={handleBadgeClick} value={getStatusNameById(userStatusObj?.statusesId)} className={`${statusClass} text-white customer-badge px-2 text-xs p-0 cursor-pointer`} style={{borderRadius: '6px 0 0 6px', backgroundColor: `${userStatusObj?.statusColor}`}}/>
                            <div className="status-selector">
                                <Dropdown
                                    ref={dropdownRef}
                                    value={userStatusObj?.statusesId}
                                    options={filteredStatusList}
                                    onChange={handleStatusChange}
                                    filter
                                    height={300}
                                    showClear
                                    panelClassName="statusName"
                                    optionLabel="statusName"
                                    optionValue="id"
                                    style={{borderRadius: '0 6px 6px 0', borderColor: userStatusObj?.statusColor}}
                                    className={classNames(`statusName`, {'p-inputtext-filled h-full shadow-none relative': userStatusObj})}
                                    // disabled={!hasUsersManagerUpdatePermission}
                                    itemTemplate={customItemTemplate}
                                />
                            </div>
                        </div>}
                    </div>

                </div>
            </div>
            <div className="flex md:hidden align-items-center mt-2 cursor-pointer" onClick={clickActive}>
                <InternetStatus/>
                {(activeTab && !props.showIconAsInactive) || (props.showIconAsInactive && userActivatedTab) ?
                    <Button icon="pi pi-phone" className="text-xl phone-icon outline-none shadow-none border-none cursor-pointer p-button-success text-white ml-2 border-circle" style={{backgroundColor: 'rgb(76, 175, 80)', width: '30px', height: '30px', fontSize: '30px'}}
                    ></Button>
                    : <Button icon="pi pi-phone" className="text-xl phone-icon outline-none shadow-none cursor-pointer p-button-success text-white mx-2 ml-0 border-circle relative overflow-visible flex justify-content-center"
                              style={{backgroundColor: '#b3bac5', width: '30px', height: '30px', fontSize: '30px', border: '1px solid red'}} onClick={clickActive}><i className="offline-icon-phone pi pi-times"></i></Button>}
                <p className="mr-2 mb-0 ml-2 text-sm">{dateTime.toLocaleDateString("uk-UA")}</p>
                <p className="mb-0 text-sm">{dateTime.toLocaleTimeString("uk-UA", {
                    hour12: false,
                    hour: "2-digit",
                    minute: "2-digit"
                })}</p>
            </div>
            <UserListDialog priority={0}/>
        </>
    );
};

export default InlineProfileMenu;
